import React from 'react';
import PropTypes from 'prop-types';

import {
  Field,
} from 'redux-form';

import TextBox from '../../../../shared/components/form/TextBox';

const StudentsScoresTable = ({
  fields = {},
  meta: { error, submitFailed },
  onChangeText,
  onSort,
  items,
  puntajeTotal,
  editScore,
  sortColumn,
  sortType,
}) => {
  const inputStyle = {
    fontSize: '16px',
    height: '28px',
    color: 'greenyellow',
    textAlign: 'center',
    fontWeight: 'bold',
  };

  const readOnlyFields = true;

  return (
    <>
      <table className="table table-striped check-in">
        <thead>
          <tr>
            <th scope="col col-2">N&uacute;mero de documento</th>
            <th
              onClick={() => onSort({ sortColumn: 'nombre', sortType })}
              scope="col col-3"
            >
              Nombre{' '}
              <i
                className={
                  `fa fa-sort-alpha-${sortColumn === 'nombre' && sortType === 'desc' ? sortType : 'asc'}`
                }
                aria-hidden="true"
              />
            </th>
            <th
              onClick={() => onSort({ sortColumn: 'apellido', sortType })}
              scope="col col-3"
            >
              Apellido{' '}
              <i
                className={`fa fa-sort-alpha-${sortColumn === 'apellido' && sortType === 'desc' ? sortType : 'asc'}`}
                aria-hidden="true"
              />
            </th>
            <th scope="col col-2">Puntaje Obtenido</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((tarea, index) => (
            <tr key={`${tarea}`} id={`${tarea}`} className={items[index] && items[index].deleted ? 'hidden' : ''}>
              <th className="col col-2">
                <div className="form" style={{ display: 'flex' }}>
                  <div
                    className="form__form-group-input-wrap form__form-group-input-wrap--error "
                    style={{ display: 'flex' }}
                  >
                    <Field
                      name={`${tarea}.numeroDocumento`}
                      component="input"
                      autoComplete="false"
                      type="text"
                      readOnly={readOnlyFields}
                      disabled={readOnlyFields}
                    />

                  </div>
                </div>
              </th>
              <th className="col col-3">
                <div className="form" style={{ display: 'flex' }}>
                  <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                    <Field
                      name={`${tarea}.nombre`}
                      component="input"
                      autoComplete="false"
                      type="text"
                      readOnly={readOnlyFields}
                      disabled={readOnlyFields}
                    />
                  </div>
                </div>
              </th>
              <th className="col col-3">
                <div className="form" style={{ display: 'flex' }}>
                  <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                    <Field
                      name={`${tarea}.apellido`}
                      component="input"
                      autoComplete="false"
                      type="text"
                      readOnly={readOnlyFields}
                      disabled={readOnlyFields}
                    />
                  </div>
                </div>
              </th>

              <th className="col col-2">
                <div className="form" style={{ display: 'flex' }}>
                  <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                    <Field
                      style={inputStyle}
                      name={`${tarea}.puntajeObtenido`}
                      type="number"
                      max={puntajeTotal}
                      min="0"
                      component={TextBox}
                      autoComplete="false"
                      onBlur={({ target }) => {
                        const puntajeObtenido = items[index] && items[index].puntajeObtenido;
                        const value = Number(target.value);

                        if (value !== puntajeObtenido) {
                          onChangeText({
                            target,
                            name: fields.name,
                            numeroDocumento: items[index] && items[index].numeroDocumento,
                          });
                        }
                      }}
                      parse={value => Number(value)}
                      readOnly={editScore}
                      disabled={editScore}
                    />
                  </div>
                </div>
              </th>

            </tr>
          ))}
        </tbody>
      </table>
      {
        submitFailed && error && (
          <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
            {error}
          </span>
        )
      }
    </>
  );
};

StudentsScoresTable.propTypes = {
  onChangeText: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  puntajeTotal: PropTypes.number,
  sortColumn: PropTypes.string,
  sortType: PropTypes.string,
  editScore: PropTypes.bool.isRequired,
};

StudentsScoresTable.defaultProps = {
  meta: {},
  puntajeTotal: 0,
  sortColumn: 'nombre',
  sortType: 'asc',
};

export default StudentsScoresTable;
